module.exports = __webpack_public_path__ + "site/img/index5-sd.dac4bfe6.png";